export default __webpack_public_path__ + "static/flowers-1-ded38e7432b94733a82a18ad37765a3e.svg";